module.exports = __webpack_public_path__ + "img/hr-level1_running_shadow.4b593d89.png";